import { render, staticRenderFns } from "./detailsOfWeightRecorded.vue?vue&type=template&id=2e4582ef&scoped=true&"
import script from "./detailsOfWeightRecorded.vue?vue&type=script&lang=js&"
export * from "./detailsOfWeightRecorded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4582ef",
  null
  
)

export default component.exports